import React from 'react';
import { Input } from '../input';

export const TextboxTypeWrapper = ({
  register, name, title, disabled, selectedType, onChangeSelectedType,
  options, error, responsiveClassName,
}) => {
  return (
    <div className={responsiveClassName}>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700"
      >
        {title}
      </label>
      <div className="mt-1 relative rounded-md shadow-sm">
        <Input
          {...register(name)}
          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-36 sm:text-sm border-gray-300 rounded-md"
          id={name}
          type="text"
          errorMessage={error}
          disabled={disabled}
        />
        <div className="absolute inset-y-0 right-0 flex items-center">
          <select
            id="type_select"
            name="type_select"
            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
            onChange={(e) => onChangeSelectedType(e.target.value)}
            value={selectedType}
            disabled={disabled}
          >
            {options.map((item) => {
              return (<option key={item.value} value={item.value}>{item.label}</option>);
            })}
          </select>
        </div>
      </div>
      {error && (
      <p className="mt-2 text-sm text-red-600" id="email-error">
        {error.message}
      </p>
      )}
    </div>
  );
};
